import React from 'react';
import { Helmet } from 'react-helmet-async';
import { 
  SITE_NAME, 
  SITE_URL, 
  DEFAULT_META_DESCRIPTION, 
  DEFAULT_META_KEYWORDS,
  GEO_FOCUS,
  OWNER_NAME,
  generateCanonicalUrl
} from '../utils/seoDataStructure';

const DEFAULT_TITLE = 'Cosmik Drones - Professional Drone Photography & Videography in Lehigh Valley, PA';
const DEFAULT_DESCRIPTION = 'Cosmik Drones provides FAA-certified drone photography and videography services throughout Lehigh Valley, PA and beyond. Specializing in FPV, aerial photography, and commercial drone services.';
const DEFAULT_CANONICAL = 'https://cosmikdrones.com/';
const DEFAULT_OG_IMAGE = 'https://cosmikdrones.com/images/og-image.jpg';
  
const SEO = ({ 
  title, 
  description = DEFAULT_META_DESCRIPTION, 
  canonicalUrl,
  ogType = 'website',
  ogImage = '/Cosmik Logo/Kolonia_Logo.png',
  location = 'Lehigh Valley, Pennsylvania',
  keywords = DEFAULT_META_KEYWORDS
}) => {
  const siteTitle = `${SITE_NAME} | ${title}`;
  const ogImageUrl = ogImage.startsWith('http') ? ogImage : `${SITE_URL}${ogImage}`;

  return (
    <Helmet>
      {/* Basic metadata */}
      <title>{siteTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={typeof keywords === 'string' ? keywords : keywords.join(', ')} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* OpenGraph tags */}
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImageUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImageUrl} />
      
      {/* Local business tags */}
      <meta name="geo.region" content="US-PA" />
      <meta name="geo.placename" content={location} />
      <meta name="geo.position" content="40.6084;-75.4907" />
      <meta name="ICBM" content="40.6084, -75.4907" />
      
      {/* Additional SEO tags */}
      <meta name="author" content={OWNER_NAME} />
    </Helmet>
  );
};

export default SEO; 